import { Rating } from '@mui/material';
import Flex from 'legacyfrontend/components/Flex';
import { usePackageCard } from 'legacyfrontend/contexts/PackageCardContext';
import { adultsQtyMapper } from 'legacyfrontend/helpers/julia-mappers';
import capitalizeWords from 'legacyfrontend/utils/capitalize-words';
import getFinalPrice from 'legacyfrontend/utils/get-final-price';
import totalNightTextSetter from 'legacyfrontend/utils/total-night-text';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const HotelInfoCard = ({
  hotelInformation,
  packageLink,
  totalNights,
  totalManager,
  providerId,
  packageConfigurationId,
}) => {
  const { t } = useTranslation(['layout']);
  const {
    packageData: { currencyCode },
  } = usePackageCard();

  const getAdultsQty = (adultsQty) => {
    const mappedQty = adultsQtyMapper(adultsQty);

    return !mappedQty
      ? '-'
      : `Precio contado viajando ${mappedQty === 1 ? '1 persona' : `${mappedQty} personas`}`;
  };

  return (
    <Flex className='package-card__dynamic-content__wrapper__hotel-list__records__card'>
      <Flex
        className='package-card__dynamic-content__wrapper__hotel-list__records__card__wrapper'
        vertical
      >
        <Flex
          className='package-card__dynamic-content__wrapper__hotel-list__records__card__hotels'
          vertical
        >
          {hotelInformation.map((item, index) => (
            <Flex
              key={`hotel-${item.hotel?.id || index}`}
              className='package-card__dynamic-content__wrapper__hotel-list__records__card__info'
              vertical
            >
              <Flex
                className='package-card__dynamic-content__wrapper__hotel-list__records__card__info__title'
                vertical
              >
                <h5>{capitalizeWords(item.hotel.name)}</h5>
                <Rating
                  className='package-card__dynamic-content__wrapper__hotel-list__records__card__info__title__rating'
                  readOnly
                  size='small'
                  value={item.hotel.category}
                />
              </Flex>
              <Flex
                className='package-card__dynamic-content__wrapper__hotel-list__records__card__info__details'
                vertical
              >
                <strong className='package-card__dynamic-content__wrapper__hotel-list__records__card__info__details__first-line'>
                  {[
                    totalNightTextSetter(providerId === 3 ? item.nights : totalNights),
                    capitalizeWords(item.regime),
                    capitalizeWords(item.roomType),
                  ].map((item, index) => (
                    <span key={`${item}-${index}`}>{item}</span>
                  ))}
                </strong>
              </Flex>
            </Flex>
          ))}
        </Flex>
        <Flex
          className='package-card__dynamic-content__wrapper__hotel-list__records__card__price'
          vertical
        >
          <span className='package__info__card__data__price'>
            {getFinalPrice({
              currencyCode,
              total: totalManager.total,
            })}
          </span>
          <span className='package__info__card__data__occupation'>
            {getAdultsQty(hotelInformation[0].occupation)}
          </span>
        </Flex>
      </Flex>
      <Link
        className='package-card__dynamic-content__wrapper__hotel-list__records__card__link'
        target='_blank'
        to={packageLink(hotelInformation, packageConfigurationId)}
      >
        {t('packages.see_detail')}
      </Link>
    </Flex>
  );
};

export default HotelInfoCard;
